import { useQuery } from "react-query";
import qs from "qs-lite";

import api from "../../utils/api";
import { periodToRange } from "../../pages/DashboardPage/helper";

const DASHBOARD = "/dashboard";
const SUMMARY = `${DASHBOARD}/summary`;
const RECENT = `${DASHBOARD}/recent`;
const GRAPHS = `${DASHBOARD}/graphs`;

const buildQuery = ({ period, startDate, endDate, location, userId } = {}) => {
  const payload = {
    ...(period ? { period } : {}),
    ...(startDate ? { startDate } : {}),
    ...(endDate ? { endDate } : {}),
    ...(location ? { location } : {}),
    ...(userId ? { userId } : {}),
  };
  const str = qs.stringify(payload);
  return str ? `?${str}` : "";
};

const getSummary = ({ queryKey }) =>
  api.get(`${SUMMARY}${buildQuery(queryKey[1])}`);

const getRecent = ({ queryKey }) =>
  api.get(`${RECENT}${buildQuery(queryKey[1])}`);

const getGraphs = ({ queryKey }) =>
  api.get(`${GRAPHS}${buildQuery(queryKey[1])}`);

const resolvePeriod = (period) => {
  const { startDate, endDate } = periodToRange(period);
  return { period, startDate, endDate };
};

export const useGetDashboardSummary = ({
  period,
  location,
  userId,
} = {}) => {
  const range = resolvePeriod(period);
  return useQuery(
    [SUMMARY, { ...range, location, userId }],
    getSummary,
    { staleTime: 60_000, keepPreviousData: true },
  );
};

export const useGetDashboardRecent = ({
  period,
  location,
  userId,
} = {}) => {
  const range = resolvePeriod(period);
  return useQuery(
    [RECENT, { ...range, location, userId }],
    getRecent,
    { staleTime: 60_000, keepPreviousData: true },
  );
};

export const useGetDashboardGraphs = ({
  period,
  location,
  userId,
} = {}) => {
  const range = resolvePeriod(period);
  return useQuery(
    [GRAPHS, { ...range, location, userId, groupBy: "day" }],
    getGraphs,
    { staleTime: 60_000, keepPreviousData: true },
  );
};
